import { useMemo } from 'react';
import React from 'react';
import { PhotoProvider, PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

interface IProps {
    visible: boolean;
    current: number;
    urls: string[];
    onClose: () => void;
    onChange?: (arg: number) => void;
    photoClosable?: boolean;
}

const PreviewImage: React.FC<IProps> = ({ visible, current, urls = [], onClose, onChange, photoClosable = false, ...rest }) => {
    const urlsArr = useMemo(() => {
        if (urls && !!urls.length) {
            const _urls = urls.filter(v => v);
            return _urls.map((item, index) => ({ src: item, key: index }));
        }
        return [];
    }, [urls]);

    return (
        <div className="xp-preview-image">
            <PhotoProvider {...rest}>
                <PhotoSlider
                    images={urlsArr}
                    photoClosable={photoClosable}
                    visible={visible}
                    onClose={onClose}
                    index={current}
                    onIndexChange={onChange}
                />
            </PhotoProvider>
        </div>
    );
};
export default PreviewImage;
